import { Card, LargeContentContainer, OverlayedLoader } from '@mews-commander/ui';
import ExchangeTable from '../ExchangeTable';

const Exchange = ({ isFetching, scope }: { isFetching: boolean; scope: string }) => (
    <LargeContentContainer condensed>
        <Card>
            <ExchangeTable scope={scope} />
        </Card>
        <OverlayedLoader show={isFetching} />
    </LargeContentContainer>
);

export default Exchange;
